import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import configData from './config.js'
import axios from './axios-auth'
import 'highlight.js'

import { ImageDrop } from 'quill-image-drop-module'
import ImageResize from 'quill-image-resize-module'
import {Quill} from 'vue-quill-editor'
import VueQuillEditor from 'vue-quill-editor'

Quill.register('modules/imageDrop', ImageDrop)
Quill.register('modules/imageResize', ImageResize)

Vue.config.productionTip = false
axios.defaults.baseURL = configData.baseURL

new Vue({  
  router,
  store,
  vuetify,
  VueQuillEditor,
  render: h => h(App)
}).$mount('#app')

/*
this.$vuetify.theme.themes.dark.primary = 'green'
this.$vuetify.theme.themes.light.primary = 'green'
this.$vuetify.theme.dark.primary = 'green'
this.$vuetify.theme.light.primary = 'green'
*/

